// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "account.proto" (package "account", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message account.CurrencyBalance
 */
export interface CurrencyBalance {
    /**
     * @generated from protobuf field: int32 currencyId = 1
     */
    currencyId: number;
    /**
     * @generated from protobuf field: int32 amount = 2
     */
    amount: number;
}
/**
 * @generated from protobuf message account.Account
 */
export interface Account {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: repeated account.CurrencyBalance balances = 3
     */
    balances: CurrencyBalance[];
    /**
     * @generated from protobuf field: bool is_mine = 4
     */
    isMine: boolean;
    /**
     * @generated from protobuf field: string type = 5
     */
    type: string;
    /**
     * @generated from protobuf field: string financial_institution = 6
     */
    financialInstitution: string;
    /**
     * @generated from protobuf field: string created_at = 7
     */
    createdAt: string;
    /**
     * @generated from protobuf field: repeated string statement_names = 8
     */
    statementNames: string[];
    /**
     * @generated from protobuf field: bool is_debt = 9
     */
    isDebt: boolean;
}
/**
 * @generated from protobuf message account.GetAllAccountsRequest
 */
export interface GetAllAccountsRequest {
}
/**
 * @generated from protobuf message account.GetAllAccountsResponse
 */
export interface GetAllAccountsResponse {
    /**
     * @generated from protobuf field: repeated account.Account accounts = 1
     */
    accounts: Account[];
}
/**
 * @generated from protobuf message account.CreateAccountRequest
 */
export interface CreateAccountRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: repeated account.CurrencyBalance balances = 2
     */
    balances: CurrencyBalance[];
    /**
     * @generated from protobuf field: bool is_mine = 3
     */
    isMine: boolean;
    /**
     * @generated from protobuf field: string type = 4
     */
    type: string;
    /**
     * @generated from protobuf field: string financial_institution = 5
     */
    financialInstitution: string;
    /**
     * @generated from protobuf field: bool is_debt = 6
     */
    isDebt: boolean;
}
/**
 * @generated from protobuf message account.CreateAccountResponse
 */
export interface CreateAccountResponse {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message account.EditableAccountFields
 */
export interface EditableAccountFields {
    /**
     * @generated from protobuf field: optional string name = 1
     */
    name?: string;
    /**
     * @generated from protobuf field: bool update_balances = 2
     */
    updateBalances: boolean;
    /**
     * @generated from protobuf field: repeated account.CurrencyBalance balances = 3
     */
    balances: CurrencyBalance[];
    /**
     * @generated from protobuf field: optional string type = 5
     */
    type?: string;
    /**
     * @generated from protobuf field: optional string financial_institution = 6
     */
    financialInstitution?: string;
    /**
     * @generated from protobuf field: optional bool is_debt = 7
     */
    isDebt?: boolean;
}
/**
 * @generated from protobuf message account.UpdateAccountRequest
 */
export interface UpdateAccountRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: account.EditableAccountFields fields = 2
     */
    fields?: EditableAccountFields;
}
/**
 * @generated from protobuf message account.UpdateAccountResponse
 */
export interface UpdateAccountResponse {
}
/**
 * @generated from protobuf message account.DeleteAccountRequest
 */
export interface DeleteAccountRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: optional uint32 replacement_id = 2
     */
    replacementId?: number;
    /**
     * @generated from protobuf field: bool delete_transactions = 3
     */
    deleteTransactions: boolean;
}
/**
 * @generated from protobuf message account.DeleteAccountResponse
 */
export interface DeleteAccountResponse {
    /**
     * @generated from protobuf field: uint32 affected_transactions = 1
     */
    affectedTransactions: number;
    /**
     * @generated from protobuf field: uint32 moved_to_unconfirmed = 2
     */
    movedToUnconfirmed: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class CurrencyBalance$Type extends MessageType<CurrencyBalance> {
    constructor() {
        super("account.CurrencyBalance", [
            { no: 1, name: "currencyId", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "amount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CurrencyBalance>): CurrencyBalance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.currencyId = 0;
        message.amount = 0;
        if (value !== undefined)
            reflectionMergePartial<CurrencyBalance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CurrencyBalance): CurrencyBalance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 currencyId */ 1:
                    message.currencyId = reader.int32();
                    break;
                case /* int32 amount */ 2:
                    message.amount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CurrencyBalance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 currencyId = 1; */
        if (message.currencyId !== 0)
            writer.tag(1, WireType.Varint).int32(message.currencyId);
        /* int32 amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Varint).int32(message.amount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.CurrencyBalance
 */
export const CurrencyBalance = new CurrencyBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Account$Type extends MessageType<Account> {
    constructor() {
        super("account.Account", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "balances", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CurrencyBalance },
            { no: 4, name: "is_mine", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "financial_institution", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "statement_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "is_debt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Account>): Account {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.name = "";
        message.balances = [];
        message.isMine = false;
        message.type = "";
        message.financialInstitution = "";
        message.createdAt = "";
        message.statementNames = [];
        message.isDebt = false;
        if (value !== undefined)
            reflectionMergePartial<Account>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Account): Account {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated account.CurrencyBalance balances */ 3:
                    message.balances.push(CurrencyBalance.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_mine */ 4:
                    message.isMine = reader.bool();
                    break;
                case /* string type */ 5:
                    message.type = reader.string();
                    break;
                case /* string financial_institution */ 6:
                    message.financialInstitution = reader.string();
                    break;
                case /* string created_at */ 7:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string statement_names */ 8:
                    message.statementNames.push(reader.string());
                    break;
                case /* bool is_debt */ 9:
                    message.isDebt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Account, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated account.CurrencyBalance balances = 3; */
        for (let i = 0; i < message.balances.length; i++)
            CurrencyBalance.internalBinaryWrite(message.balances[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool is_mine = 4; */
        if (message.isMine !== false)
            writer.tag(4, WireType.Varint).bool(message.isMine);
        /* string type = 5; */
        if (message.type !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.type);
        /* string financial_institution = 6; */
        if (message.financialInstitution !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.financialInstitution);
        /* string created_at = 7; */
        if (message.createdAt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string statement_names = 8; */
        for (let i = 0; i < message.statementNames.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.statementNames[i]);
        /* bool is_debt = 9; */
        if (message.isDebt !== false)
            writer.tag(9, WireType.Varint).bool(message.isDebt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.Account
 */
export const Account = new Account$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllAccountsRequest$Type extends MessageType<GetAllAccountsRequest> {
    constructor() {
        super("account.GetAllAccountsRequest", []);
    }
    create(value?: PartialMessage<GetAllAccountsRequest>): GetAllAccountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllAccountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllAccountsRequest): GetAllAccountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllAccountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.GetAllAccountsRequest
 */
export const GetAllAccountsRequest = new GetAllAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllAccountsResponse$Type extends MessageType<GetAllAccountsResponse> {
    constructor() {
        super("account.GetAllAccountsResponse", [
            { no: 1, name: "accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Account }
        ]);
    }
    create(value?: PartialMessage<GetAllAccountsResponse>): GetAllAccountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accounts = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllAccountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllAccountsResponse): GetAllAccountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated account.Account accounts */ 1:
                    message.accounts.push(Account.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllAccountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated account.Account accounts = 1; */
        for (let i = 0; i < message.accounts.length; i++)
            Account.internalBinaryWrite(message.accounts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.GetAllAccountsResponse
 */
export const GetAllAccountsResponse = new GetAllAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountRequest$Type extends MessageType<CreateAccountRequest> {
    constructor() {
        super("account.CreateAccountRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "balances", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CurrencyBalance },
            { no: 3, name: "is_mine", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "financial_institution", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_debt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountRequest>): CreateAccountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.balances = [];
        message.isMine = false;
        message.type = "";
        message.financialInstitution = "";
        message.isDebt = false;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountRequest): CreateAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* repeated account.CurrencyBalance balances */ 2:
                    message.balances.push(CurrencyBalance.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_mine */ 3:
                    message.isMine = reader.bool();
                    break;
                case /* string type */ 4:
                    message.type = reader.string();
                    break;
                case /* string financial_institution */ 5:
                    message.financialInstitution = reader.string();
                    break;
                case /* bool is_debt */ 6:
                    message.isDebt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* repeated account.CurrencyBalance balances = 2; */
        for (let i = 0; i < message.balances.length; i++)
            CurrencyBalance.internalBinaryWrite(message.balances[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool is_mine = 3; */
        if (message.isMine !== false)
            writer.tag(3, WireType.Varint).bool(message.isMine);
        /* string type = 4; */
        if (message.type !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.type);
        /* string financial_institution = 5; */
        if (message.financialInstitution !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.financialInstitution);
        /* bool is_debt = 6; */
        if (message.isDebt !== false)
            writer.tag(6, WireType.Varint).bool(message.isDebt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.CreateAccountRequest
 */
export const CreateAccountRequest = new CreateAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse$Type extends MessageType<CreateAccountResponse> {
    constructor() {
        super("account.CreateAccountResponse", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountResponse>): CreateAccountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountResponse): CreateAccountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.CreateAccountResponse
 */
export const CreateAccountResponse = new CreateAccountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EditableAccountFields$Type extends MessageType<EditableAccountFields> {
    constructor() {
        super("account.EditableAccountFields", [
            { no: 1, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "update_balances", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "balances", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CurrencyBalance },
            { no: 5, name: "type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "financial_institution", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_debt", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EditableAccountFields>): EditableAccountFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.updateBalances = false;
        message.balances = [];
        if (value !== undefined)
            reflectionMergePartial<EditableAccountFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EditableAccountFields): EditableAccountFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string name */ 1:
                    message.name = reader.string();
                    break;
                case /* bool update_balances */ 2:
                    message.updateBalances = reader.bool();
                    break;
                case /* repeated account.CurrencyBalance balances */ 3:
                    message.balances.push(CurrencyBalance.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string type */ 5:
                    message.type = reader.string();
                    break;
                case /* optional string financial_institution */ 6:
                    message.financialInstitution = reader.string();
                    break;
                case /* optional bool is_debt */ 7:
                    message.isDebt = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EditableAccountFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string name = 1; */
        if (message.name !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* bool update_balances = 2; */
        if (message.updateBalances !== false)
            writer.tag(2, WireType.Varint).bool(message.updateBalances);
        /* repeated account.CurrencyBalance balances = 3; */
        for (let i = 0; i < message.balances.length; i++)
            CurrencyBalance.internalBinaryWrite(message.balances[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional string type = 5; */
        if (message.type !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.type);
        /* optional string financial_institution = 6; */
        if (message.financialInstitution !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.financialInstitution);
        /* optional bool is_debt = 7; */
        if (message.isDebt !== undefined)
            writer.tag(7, WireType.Varint).bool(message.isDebt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.EditableAccountFields
 */
export const EditableAccountFields = new EditableAccountFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccountRequest$Type extends MessageType<UpdateAccountRequest> {
    constructor() {
        super("account.UpdateAccountRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "fields", kind: "message", T: () => EditableAccountFields }
        ]);
    }
    create(value?: PartialMessage<UpdateAccountRequest>): UpdateAccountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccountRequest): UpdateAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* account.EditableAccountFields fields */ 2:
                    message.fields = EditableAccountFields.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* account.EditableAccountFields fields = 2; */
        if (message.fields)
            EditableAccountFields.internalBinaryWrite(message.fields, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.UpdateAccountRequest
 */
export const UpdateAccountRequest = new UpdateAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccountResponse$Type extends MessageType<UpdateAccountResponse> {
    constructor() {
        super("account.UpdateAccountResponse", []);
    }
    create(value?: PartialMessage<UpdateAccountResponse>): UpdateAccountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateAccountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccountResponse): UpdateAccountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.UpdateAccountResponse
 */
export const UpdateAccountResponse = new UpdateAccountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAccountRequest$Type extends MessageType<DeleteAccountRequest> {
    constructor() {
        super("account.DeleteAccountRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "replacement_id", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "delete_transactions", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteAccountRequest>): DeleteAccountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.deleteTransactions = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAccountRequest): DeleteAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* optional uint32 replacement_id */ 2:
                    message.replacementId = reader.uint32();
                    break;
                case /* bool delete_transactions */ 3:
                    message.deleteTransactions = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* optional uint32 replacement_id = 2; */
        if (message.replacementId !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.replacementId);
        /* bool delete_transactions = 3; */
        if (message.deleteTransactions !== false)
            writer.tag(3, WireType.Varint).bool(message.deleteTransactions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.DeleteAccountRequest
 */
export const DeleteAccountRequest = new DeleteAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAccountResponse$Type extends MessageType<DeleteAccountResponse> {
    constructor() {
        super("account.DeleteAccountResponse", [
            { no: 1, name: "affected_transactions", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "moved_to_unconfirmed", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteAccountResponse>): DeleteAccountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.affectedTransactions = 0;
        message.movedToUnconfirmed = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteAccountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAccountResponse): DeleteAccountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 affected_transactions */ 1:
                    message.affectedTransactions = reader.uint32();
                    break;
                case /* uint32 moved_to_unconfirmed */ 2:
                    message.movedToUnconfirmed = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAccountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 affected_transactions = 1; */
        if (message.affectedTransactions !== 0)
            writer.tag(1, WireType.Varint).uint32(message.affectedTransactions);
        /* uint32 moved_to_unconfirmed = 2; */
        if (message.movedToUnconfirmed !== 0)
            writer.tag(2, WireType.Varint).uint32(message.movedToUnconfirmed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message account.DeleteAccountResponse
 */
export const DeleteAccountResponse = new DeleteAccountResponse$Type();
/**
 * @generated ServiceType for protobuf service account.AccountService
 */
export const AccountService = new ServiceType("account.AccountService", [
    { name: "GetAllAccounts", options: {}, I: GetAllAccountsRequest, O: GetAllAccountsResponse },
    { name: "CreateAccount", options: {}, I: CreateAccountRequest, O: CreateAccountResponse },
    { name: "UpdateAccount", options: {}, I: UpdateAccountRequest, O: UpdateAccountResponse },
    { name: "DeleteAccount", options: {}, I: DeleteAccountRequest, O: DeleteAccountResponse }
]);
